export function setExpiresTime(expires) {
  return {
    type: 'EXPIRES_TIME',
    expires
  };
}
